import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IUserDonationReducer, IUserDonationResponse} from '../../utils/types';

export const pendingOperation = (state: IUserDonationReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IUserDonationReducer) => {
	state.isLoading = false;
};

export const getDonationListOperation = (
	state: IUserDonationReducer,
	{payload}: PayloadAction<IUserDonationResponse>
) => {
	state.totalDonationsAmount = payload.totalDonationsAmount;
	state.donations = payload.donations;
	state.isLoading = false;
};
